import React from 'react';
import styled from 'styled-components';
import { useState, useEffect } from 'react';
import { HeadingWrap, Span } from '../../../../Styles/CommonStyles';
import ConsumInboxTable from './ConsumInboxTable';
import ConsumIssueDetails from '../ConsumIssueReq/ConsumIssueDetails';
import BoToStoreConsumDetails from '../BoToStoreConsumReq/BoToStoreConsumDetails';
import { useMarkConsumableAsReadMutation } from '../../../../features/consumablerequest/consumableReqApiSlice';

const Container = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`;
const Wrapper = styled.div``


const ConsumInbox = ({subTabValue, resetTrigger}) => {
  const [row, setRow] = useState('')
  const [changepage, setChangepage] = useState([true, false, false, false, false])
  const [markConsumableAsRead] = useMarkConsumableAsReadMutation();


  useEffect(() => {
    if (resetTrigger > 0) {
      setChangepage([true, false, false, false, false]);
      // Reset any other state variables that need resetting
    }
  },[resetTrigger])

  const handleEditclick = async (e, row, reqtype) => {
    console.log(reqtype);
    setRow(row);
    
    // Mark the request as read when user clicks view/action button
    try {
      await markConsumableAsRead({
        requestId: row._id || row.id,
        requestType: 'consumable'
      }).unwrap();
      console.log('Consumable request marked as read successfully');
    } catch (error) {
      console.error('Error marking consumable request as read:', error);
    }
  
    if (["ConsumableIssue"].includes(reqtype)) {
      setChangepage([false, true, false, false, false]);
    } else if (["BoToStoreConsumIssue"].includes(reqtype)) {
      setChangepage([false, false, true, false, false]);
    } else if (["BO_User_Transfer", "BO_Store_Return"].includes(reqtype)) {
      setChangepage([false, false, false, true, false]);
    } else if (reqtype === "direct") {
      setChangepage([false, false, false, false, true]);
    }
  };
  
  return (
    <Container>
      <Wrapper>

        {(changepage[0] ) && <ConsumInboxTable subTabValue={subTabValue}  handleEditclick={handleEditclick} />}
        {(changepage[1] ) && <ConsumIssueDetails row={row} subTabValue={subTabValue} setChangepage={setChangepage} />}
        {(changepage[2] ) && <BoToStoreConsumDetails row={row} subTabValue={subTabValue} setChangepage={setChangepage} />}
        {/* {(changepage[1] ) && <AssetRequestDetails row={row} setChangepage={setChangepage} />}
        {(changepage[2] ) && <UserAsstRtrnReqDetails row={row} setChangepage={setChangepage} />}
        {(changepage[3] ) && <BoAsstRtrnReqDetails row={row} setChangepage={setChangepage} />} */}
      </Wrapper>
    </Container>
  );
};

export default ConsumInbox; 